import SubCategory from './SubCategory';

export default SubCategory;


// WEBPACK FOOTER //
// ./src/components/SubCategory/index.tsx